import { IComponentOptions } from 'angular';
import { RegentsPlanningStepperTransferCtrl } from './regents-planning-stepper-transfer.controller';

export const RegentsPlanningStepperTransferComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    courseDiffs: '<',
  },
  controller: RegentsPlanningStepperTransferCtrl,
  template: require('./regents-planning-stepper-transfer.html'),
};
